import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo } from 't4core';


@Component({
  selector: 'content-header',
  templateUrl: './content-header.html',
  styleUrls: ['./content-header.css'],
  standalone: false
})
export class ContentHeaderComponent extends ComponentBase implements OnInit {

  @Input() public keyboardOpen: boolean = false;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
